<template>
    <div>
        <span class="text-danger mb-2 d-block" v-if="showSelectSpecificChannelError"
            >Your target groups are adjusted in the response. Only target group A3-99 is available for reach for individual channel combinations.</span
        >
        <div class="d-flex flex-wrap justify-content-between">
            <div class="d-flex flex-wrap">
                <b-button class="mb-2 mr-2 btn-responsive" size="sm" variant="primary" :disabled="levelOneSitesWithLevelTwoSites.length === 0" @click="toggleSelectAllRows()">
                    {{ allSelected ? "Deselect all rows" : "Select all rows" }}
                </b-button>
                <b-button
                    class="mb-2 mr-2 btn-responsive"
                    size="sm"
                    variant="danger"
                    disabled
                    @click="excludeSelected(), (allSelected = true), toggleSelectAllRows()"
                >
                    Exclude rows
                </b-button>
                <label class="totalRowsStyle mb-2 mr-5"> Response rows: {{ getRowCount }} </label>
            </div>
            <span v-show="resultsIncludesTvOrOnlineTargetSource" style="font-size: 0.8rem;" class="text-right align-self-end mb-2"
                >* TV and online data are components for calculating the total, not exactly the same as the values for TV and online video.</span
            >
        </div>

        <b-table
            no-sort-reset
            thead-class="stickyfancytableheader"
            :fields="fields"
            class="tablemainresultclass"
            :per-page="visibleRows"
            :current-page="currentPage"
            ref="selectableTable"
            :items="levelOneSitesWithLevelTwoSites"
            bordered
            small
            primary-key="index"
            striped
            :head-variant="'dark'"
            :sort-compare-options="{ numeric: true, sensitivity: 'base' }"
            sort-compare-locale="sv"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @sort-changed="onSort"
            :no-local-sorting="true"
        >
            <template v-slot:top-row v-if="$store.getters.getChannelsSumVisible">
                <td :colspan="getFirstSummaryColspan">
                    <div class="sumrowtop">
                        <div v-for="(sum, iSum) in result.data.summary" class="sumrowdiv" v-bind:key="iSum">
                            <span>{{ sum.name }}:</span>
                        </div>
                    </div>
                </td>
                <td v-for="(measure, iMeasure) in fields.filter(c => c.isMeasure)" class="text-right" v-bind:key="iMeasure" colspan="1">
                    <div v-for="(sum, iSum) in result.data.summary" class="sumrowdiv" v-bind:key="iSum">
                        {{ sum.measures[measure.key] }}
                    </div>
                </td>
            </template>
            <template v-slot:cell(plussign)="row">
                <div class="plusminuscontainer" v-if="row.item.numberOfLvl2Objects > 1">
                    <div @click="clickedPlusMinusSign(row)" class="plusminusbutton">
                        <font-awesome-icon v-if="!row.item._showDetails" icon="fa fa-plus-circle" class="plusminusicon" />
                        <font-awesome-icon v-else icon="fa fa-minus-circle fa-1x" class="plusminusicon" />
                        <div class="plusminusline"></div>
                    </div>
                </div>
                <div v-else-if="row.item.numberOfLvl2Objects === 1">
                    {{ setLevelOneSiteToLevelTwoSite(row.item) }}
                </div>
            </template>
            <template v-slot:cell(chosen)="row">
                <b-form-checkbox
                    class="choose-checkbox-div"
                    v-model="row.item.chosen"
                    @change="onLvlOneCheckClick(row.item), checkSelection(), shiftClick(row)"
                    :indeterminate.sync="row.item.indeterminate"
                ></b-form-checkbox>
            </template>
            <template v-slot:head()="field">
                <span class="measureheader" v-html="getTableFieldLabel(field)"></span>
            </template>
            <template v-slot:cell(providerName)="row">
                <span v-if="row.item.providerNameVhtml != undefined" v-html="row.item.providerNameVhtml"></span>
                <span v-else>{{ row.item.providerName }}</span>
            </template>
            <template #row-details="lvlOneRow">
                <b-table-lite
                    class="mb-0 detail-row-table"
                    :class="groupClassOddEven(lvlOneRow.index)"
                    :tbody-tr-class="detailRowClassOddEven(lvlOneRow.index)"
                    borderless
                    thead-class="hideheader"
                    :fields="fields"
                    :items="lvlOneRow.item.levelTwoSites"
                >
                    <template v-slot:cell(chosen)="lvlTwoRow">
                        <b-form-checkbox
                            class="choose-checkbox-div"
                            v-model="lvlTwoRow.item.chosen"
                            @change="checkSelection(), shiftClickLvlTwo(lvlTwoRow, lvlOneRow), anyLevelTwoSelected(lvlOneRow)"
                        ></b-form-checkbox>
                    </template>
                    <template v-slot:cell(providerName)="lvlTwoRow">
                        <span v-if="lvlTwoRow.item.providerNameVhtml != undefined" v-html="lvlTwoRow.item.providerNameVhtml"></span>
                        <span v-else>{{ lvlTwoRow.item.providerName }}</span>
                    </template>
                </b-table-lite>
            </template>
        </b-table>
        <b-pagination
            class="justify-content-center"
            v-model="currentPage"
            :total-rows="$store.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites.length"
            :per-page="visibleRows"
            aria-controls="my-table"
            @change="pageChange"
        ></b-pagination>
    </div>
</template>
<script>
import globalConfig from "@/mixins/globalConfig"
import { sortResultTable } from "../../../api/utils.js"
import * as Mutations from "@/store/modules/channels/mutation-types"

export default {
    name: "ResultTableMainChannel",
    props: ["sortBy", "sortDesc"],
    mixins: [globalConfig],
    data() {
        return {
            allSelected: false,
            selectClickedRow: true,
            visibleRows: 50,
            callOnce: false,
            currentPage: 1,
            shiftHeld: false,
            currentlySelectedRowIdx: null,
            previouslySelectedRowIdx: null,
            currentlySelectedRowLvlTwoIdx: null,
            previouslySelectedRowLvlTwoIdx: null,
            clickedLvlTwoTableIdx: null,
        }
    },
    async mounted() {
        const _self = this
        document.addEventListener("mousedown", function(e) {
            _self.shiftHeld = e.shiftKey
            if (e.shiftKey == true) {
                e.preventDefault()
            }
        })
        await this.loadGlobalConfigFromFile()
        sortResultTable({ sortBy: this.sortBy, sortDesc: this.sortDesc, isNumber: false }, this.levelOneSitesWithLevelTwoSites)
    },
    computed: {
        result() {
            return this.$store.getters.getChannelsResults
        },
        getFirstSummaryColspan() {
            return this.fields.filter(c => !c.isMeasure).length
        },
        showSelectSpecificChannelError() {
            return this.$store.getters.getChannelsResults.showSelectSpecificChannelError
        },
        getRowCount() {
            let totalLength = this.$store.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites.length
            let previousRowsAndCurrentRows = this.visibleRows * this.currentPage
            if (previousRowsAndCurrentRows > totalLength) {
                return `${totalLength}/${totalLength}`
            }
            return `${previousRowsAndCurrentRows}/${totalLength}`
        },
        levelOneSitesWithLevelTwoSites() {
            return this.$store.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites
        },
        fields() {
            let fields = [...this.$store.getters.getChannelsResults.data.columns]

            if (this.$store.getters.getChannelsExportQuery.grouptime !== "week") {
                var filteredArray = fields.filter(function(obj) {
                    return obj.key !== "week"
                })

                fields = filteredArray
            }

            fields.unshift(
                { key: "plussign", tdClass: "plusminussigntd", thClass: "plusminussignth", label: "", isMeasure: false },
                { key: "chosen", thClass: "choose-checkbox-th", label: "Selected", isMeasure: false }
            )
            for (const field of fields) {
                if (field.key.includes("measure")) {
                    field.sortDirection = "desc"
                }
            }
            return fields
        },
        resultsIncludesTvOrOnlineTargetSource() {
            return this.$store.getters.getChannelsQueryForApi.measures.some(measure => {
                const sourceUpper = measure.source.toUpperCase()
                return sourceUpper.includes("TV") || sourceUpper.includes("ONLINE")
            })
        },
    },

    methods: {
        pageChange() {
            this.currentlySelectedRowIdx = null
            this.previouslySelectedRowIdx = null
        },
        onSort(sortInfo) {
            this.$store.commit("setChannelsHaveSelectedRow", false)
            this.allSelected = false
            for (let levelOneSite of this.levelOneSitesWithLevelTwoSites) {
                levelOneSite.chosen = false
                this.onLvlOneCheckClick(levelOneSite)
            }
            this.currentlySelectedRowIdx = null
            this.previouslySelectedRowIdx = null
            this.$emit("update:sortBy", sortInfo.sortBy)
            this.$emit("update:sortDesc", sortInfo.sortDesc)
            if (sortInfo.sortBy.includes("measure")) sortInfo.isNumber = true
            else sortInfo.isNumber = this.$store.getters.getChannelsColumnTypes.find(ad => ad.value === sortInfo.sortBy).isNumber
            sortResultTable(sortInfo, this.levelOneSitesWithLevelTwoSites)
        },
        setLevelOneSiteToLevelTwoSite(row) {
            let levelTwoProgram = row.levelTwoSites
            let columnKeys = this.$store.getters.getChannelsResults.data.columns.map(column => column.key)
            for (let i = 0; i < columnKeys.length; i++) {
                row[columnKeys[i]] = levelTwoProgram[0][columnKeys[i]]
            }
        },
        onLvlOneCheckClick(row) {
            let levelTwoSites = row.levelTwoSites
            levelTwoSites.map(c => (c.chosen = row.chosen))
        },
        checkSelection() {
            let hasSelection = this.$store.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites
                .map(p => p.levelTwoSites)
                .flat()
                .some(l2 => {
                    return l2.chosen
                })
            this.$store.commit("setChannelsHaveSelectedRow", hasSelection)
        },
        shiftClick(row) {
            if (row.item.chosen) {
                if (this.currentlySelectedRowIdx !== null) {
                    this.previouslySelectedRowIdx = this.currentlySelectedRowIdx
                }
                let previousRows = 0
                if (this.currentPage > 1) previousRows = this.visibleRows * (this.currentPage - 1)
                this.currentlySelectedRowIdx = previousRows + row.index
                if (this.currentlySelectedRowIdx === null || this.previouslySelectedRowIdx === null) return
                if (this.shiftHeld && this.currentlySelectedRowIdx != this.previouslySelectedRowIdx) {
                    let sliceFrom = 0
                    let sliceTo = 0
                    if (this.currentlySelectedRowIdx < this.previouslySelectedRowIdx) {
                        sliceFrom = this.currentlySelectedRowIdx
                        sliceTo = this.previouslySelectedRowIdx
                    } else {
                        sliceFrom = this.previouslySelectedRowIdx
                        sliceTo = this.currentlySelectedRowIdx
                    }
                    var shiftClickedLvlOneSites = this.levelOneSitesWithLevelTwoSites.slice(sliceFrom, sliceTo + 1)
                    for (let levelOneSite of shiftClickedLvlOneSites) {
                        levelOneSite.chosen = true
                        this.onLvlOneCheckClick(levelOneSite)
                    }
                }
            } else {
                this.currentlySelectedRowIdx = null
                this.previouslySelectedRowIdx = null
            }
        },
        shiftClickLvlTwo(lvlTwoRow, lvlOneRow) {
            if (lvlTwoRow.item.chosen) {
                if (lvlOneRow.index !== this.clickedLvlTwoTableIdx) {
                    this.currentlySelectedRowLvlTwoIdx = null
                    this.previouslySelectedRowLvlTwoIdx = null
                }
                this.clickedLvlTwoTableIdx = lvlOneRow.index
                if (this.currentlySelectedRowLvlTwoIdx !== null) {
                    this.previouslySelectedRowLvlTwoIdx = this.currentlySelectedRowLvlTwoIdx
                }
                this.currentlySelectedRowLvlTwoIdx = lvlTwoRow.index
                if (this.currentlySelectedRowLvlTwoIdx === null || this.previouslySelectedRowLvlTwoIdx === null) return
                if (this.shiftHeld && this.currentlySelectedRowLvlTwoIdx != this.previouslySelectedRowLvlTwoIdx) {
                    let sliceFrom = 0
                    let sliceTo = 0
                    if (this.currentlySelectedRowLvlTwoIdx < this.previouslySelectedRowLvlTwoIdx) {
                        sliceFrom = this.currentlySelectedRowLvlTwoIdx
                        sliceTo = this.previouslySelectedRowLvlTwoIdx
                    } else {
                        sliceFrom = this.previouslySelectedRowLvlTwoIdx
                        sliceTo = this.currentlySelectedRowLvlTwoIdx
                    }
                    var shiftClickedLvlTwoChannels = lvlOneRow.item.levelTwoSites.slice(sliceFrom, sliceTo + 1)
                    for (let shiftClickedLvlTwoChannel of shiftClickedLvlTwoChannels) {
                        shiftClickedLvlTwoChannel.chosen = true
                    }
                }
            } else {
                this.currentlySelectedRowLvlTwoIdx = null
                this.previouslySelectedRowLvlTwoIdx = null
            }
        },
        clickedPlusMinusSign(row) {
            event.stopPropagation()
            this.$set(row.item, "_showDetails", !row.item._showDetails)
            this.selectClickedRow = false
        },
        detailRowClassOddEven(index) {
            return index % 2 == 0 ? "row-even detail-row" : "row-odd detail-row"
        },
        groupClassOddEven(index) {
            return index % 2 == 0 ? "group-even" : "group-odd"
        },
        getTableFieldLabel(field) {
            if (!field.field.key.includes("measure")) {
                return field.field.label
            }

            if (field.field.subHeader.includes("(tv-data)")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("(tv-data)", "")
                field.field.sourceHeader = "(tv-data)*"
            } else if (field.field.subHeader.includes("(online-data)")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("(online-data)", "")
                field.field.sourceHeader = "(online-data)*"
            } else if (field.field.subHeader.includes("Total")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("Total", "")
                field.field.sourceHeader = "Total"
            }

            return `${field.field.header} <span class="measureagewrapper">${field.field.targetGroupHeader}</span><span class="measureagewrapper">${field.field.sourceHeader}</span>`
        },
        excludeSelected() {
            this.$store.commit(Mutations.setChannelsSumVisible, false)
            this.$store.commit(Mutations.setChannelsHasExcludedRow, true)
            let excludedRows = []
            let selectedGroupTime = this.$store.getters.getChannelsQuery.grouptime
            if (selectedGroupTime === "week")
                excludedRows = [
                    ...this.$store.getters.getChannelsExcludedRows,
                    ...this.levelOneSitesWithLevelTwoSites
                        .map(s => s.levelTwoSites)
                        .flat()
                        .filter(s => s.chosen)
                        .map(s => ({ providerKey: s.providerKey, week: s.week, year: s.year })),
                ]
            else {
                excludedRows = [
                    ...this.$store.getters.getChannelsExcludedRows,
                    ...this.levelOneSitesWithLevelTwoSites
                        .map(s => s.levelTwoSites)
                        .flat()
                        .filter(s => s.chosen)
                        .map(s => ({ providerKey: s.providerKey })),
                ]
            }
            this.$store.commit(Mutations.setChannelsExcludedRows, excludedRows)
            let remainingResults = this.levelOneSitesWithLevelTwoSites.reduce((result, l1) => {
                l1.chosen = false
                const prevL2sLength = l1.levelTwoSites.length
                l1.levelTwoSites = l1.levelTwoSites.filter(l2 => {
                    //set chosen to false for all l2s so UI is updated, to avoid timing issues on large sets
                    const isChosen = l2.chosen
                    l2.chosen = false
                    return !isChosen
                })
                if (!l1.levelTwoSites?.length) {
                    return result
                } else if (prevL2sLength === l1.levelTwoSites.length) {
                    result.push(l1)
                    return result
                } else if (l1.levelTwoSites.length === 1) {
                    l1._showDetails = false
                    l1.numberOfLvl2Objects = l1.levelTwoSites.length
                    result.push(l1)
                    return result
                } else {
                    this.updateLevelOneSitesFromLevelTwoSites(l1)
                    l1.numberOfLvl2Objects = l1.levelTwoSites.length
                    result.push(l1)
                    return result
                }
            }, [])
            const updatedResults = {
                ...this.$store.getters.getChannelsResults,
                data: {
                    ...this.$store.getters.getChannelsResults.data,
                    levelOneSitesWithLevelTwoSites: remainingResults,
                },
            }
            this.$store.commit(Mutations.setChannelsResults, updatedResults)
            this.currentlySelectedRowIdx = null
            this.previouslySelectedRowIdx = null
        },
        toggleSelectAllRows() {
            this.allSelected = !this.allSelected
            for (const l1 of this.levelOneSitesWithLevelTwoSites) {
                l1.indeterminate = false
            }
            //checkbox indeterminate status is lagging, wait to set chosen status
            this.$nextTick(() => {
                for (const l1 of this.levelOneSitesWithLevelTwoSites) {
                    l1.chosen = this.allSelected
                    if (l1.numberOfLvl2Objects > 0) {
                        for (const l2 of l1.levelTwoSites) {
                            l2.chosen = this.allSelected
                        }
                    }
                }
            })
            this.$store.commit(Mutations.setChannelsHaveSelectedRow, this.allSelected)
        },
        updateLevelOneSitesFromLevelTwoSites(l1) {
            for (const column of this.$store.getters.getChannelsResults.data.columns) {
                let l2Values = new Set()
                for (const l2 of l1.levelTwoSites) {
                    l2Values.add(l2[column.key])
                }
                if (column.key == "providerName") {
                    l1[column.key] = [...l2Values].toString()
                } else if (l2Values.size == 1) {
                    l1[column.key] = [...l2Values].toString()
                }
            }
        },
        anyLevelTwoSelected(row) {
            row.item.indeterminate = false
            row.item.chosen = false
            let chosen = 0
            for (const l2 of row.item.levelTwoSites) {
                if (l2.chosen) {
                    chosen++
                }
            }
            if (chosen === undefined || chosen == row.item.levelTwoSites.length || chosen == 0) {
                // not indeterminate
                this.$nextTick(() => {
                    row.item.indeterminate = false
                })
                if (chosen == row.item.levelTwoSites.length) {
                    row.item.chosen = true
                    this.$nextTick(() => {
                        row.item.indeterminate = false
                    })
                } else {
                    row.item.chosen = false
                    this.$nextTick(() => {
                        row.item.indeterminate = false
                    })
                }
            } else {
                //checkbox indeterminate status is lagging, wait
                this.$nextTick(() => {
                    row.item.indeterminate = true
                })
                row.item.indeterminate = true
            }
        },
    },
}
</script>
<style scoped>
::v-deep .tablemainresultclass th {
    font-size: 0.8rem;
    background-color: #337ab7 !important;
    border-color: #bfd5e8 !important;
    border-top: white;
    border-width: 2px 1px 2px 1px !important;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
}
.resultgrey {
    background-color: #6c757d;
}
table.tablemainresultclass {
    min-width: 1200px;
    text-align: left;
    background-color: white;
    border-width: 0px 1px 1px 1px;
}
.plusminusicon {
    color: #337ab7;
    font-size: 1.25em;
    margin: auto;
    display: block;
}
::v-deep .detail-row {
    background-color: transparent !important;
}
::v-deep .detail-row td {
    font-size: 0.65rem;
}
/* table is using bootstrap striped attribute for main rows and index based css for detail rows*/
::v-deep .row-even {
    background-color: #ffffff;
}
::v-deep .row-odd {
    background-color: #f2f2f2;
}
::v-deep .group-even {
    background-color: #f2f2f2;
}
::v-deep .group-odd {
    background-color: #ffffff;
}
::v-deep tbody tr td {
    border-bottom: none;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
::v-deep .titleheadercolumn {
    width: 20%;
}
::v-deep .plusminusbutton {
    display: flex;
    position: relative;
    z-index: 2;
    padding: 0.4em 0;
    margin: -0.4em 0;
    cursor: pointer;
}
/* hiding table group borders */
::v-deep .detail-row-table tbody tr td {
    border: none;
}
::v-deep .b-table-has-details td:not(:last-child) {
    border-left: 1px solid rgba(255, 255, 255, 0);
    border-right: 1px solid rgba(255, 255, 255, 0);
}

::v-deep .b-table-has-details td:first-child {
    border-left: 1px solid #dee2e6;
    border-right: 0px solid #dee2e6;
}
::v-deep .b-table-has-details td:nth-child(2) {
    border-left: 0px solid #dee2e6;
    border-right: 0px solid #dee2e6;
}
/* constructing the hierarchy lines in the plussign column */
::v-deep .plusminussigntd {
    padding: 0;
    position: relative;
}
/* hiding the overflowing line behind transparent part of +/- icon */
::v-deep .plusminusbutton::before {
    content: "";
    background: white;
    z-index: -1;
    height: 37%;
    left: 12px;
    position: absolute;
    top: 32%;
    width: 10px;
}
::v-deep .b-table-has-details td:first-child::after {
    content: "";
    background: #a9b1b8;
    height: 42%;
    left: 16px;
    position: absolute;
    top: 60%;
    width: 0.5px;
    z-index: 1;
}
::v-deep .detail-row-table .plusminussigntd::before {
    content: "";
    background: #a9b1b8;
    width: 50%;
    left: 16px;
    position: absolute;
    top: 50%;
    height: 0.5px;
}
::v-deep .detail-row-table .plusminussigntd:first-child::after {
    content: "";
    background: #a9b1b8;
    height: 100%;
    left: 16px;
    position: absolute;
    top: -50%;
    width: 0.5px;
}
</style>
